import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ItemsService {
  constructor(private _HttpClient: HttpClient) { }

  createItem(formData: FormData): Observable<any> {
    return this._HttpClient.post(
      `${environment.Server_URL}/create/stock`,
      formData
    );
  }

  addExistingProductsToWarehouse(body: any): Observable<any> {
    return this._HttpClient.post(
      `${environment.Server_URL}/stocks/add-existing-products`,
      body
    );
  }

  editItem(formData: FormData, id: string): Observable<any> {
    return this._HttpClient.post(
      `${environment.Server_URL}/update/stock/` + id,
      formData
    );
  }
  getWearHouses(): Observable<any> {
    return this._HttpClient.get(environment.Server_URL + '/warehouses/all/data');
  }

  getStocksByWarehouse(warehouseId: number | string, page: number = 1, perPage: number = 100): Observable<any> {
    return this._HttpClient.get(
      `${environment.Server_URL}/stocks/warehouse?warehouse_id=${warehouseId}&page=${page}&per_page=${perPage}`
    );
  }

  getAllStocks(): Observable<any> {
    return this._HttpClient.get(environment.Server_URL + '/index/stocks');
  }

  getHomeWarehouseStocks(warehouseId: number | string, page: number = 1, perPage: number = 10): Observable<any> {
    const body = new FormData();
    body.append('warehouse_id', String(warehouseId));
    body.append('page', String(page));
    body.append('per_page', String(perPage));

    return this._HttpClient.post(`${environment.Server_URL}/warehouses/stocks`, body);
  }

  getAvailableSystemProducts(
    warehouseId: number | string,
    categoryId: number | string,
    page: number = 1,
    perPage: number = 10
  ): Observable<any> {
    return this._HttpClient.get(
      `${environment.Server_URL}/stocks/available-system-products?warehouse_id=${warehouseId}&category_id=${categoryId}&page=${page}&per_page=${perPage}`
    );
  }

}
